import BaseService from './base';
import request from '@/utils/request';

export interface HotChapterViewModel {
  id?: any;
  literatureID?: string;
  chapterID?: string;
  count?: number;
}


export class HotChapterService extends BaseService<HotChapterViewModel> {
  protected serviceApi: string = 'HotChapter';

  get NewModel(): HotChapterViewModel {
    return {
      chapterID: '',
    };
  }

  public GetHotChapter(id: string, count: number) {
    return request({
      url: `${this.serviceApi}/GetHotChapter/${id}/${count}`,
      method: 'get',
    });
  }


}
